import styled from 'styled-components'
import { defaultTransition } from '../../theme'
import CustomMarkdown from '../Library/CustomMarkdown'

export default function TaskDescription({ children }: { children: string }) {
  return (
    <DescriptionCont className="task-description">
      <CustomMarkdown>{children}</CustomMarkdown>
    </DescriptionCont>
  )
}

const DescriptionCont = styled.span`
  a {
    color: ${({ theme }) => theme.colors.brandPrimary};
    border-bottom: 1px solid;
    cursor: pointer;
    opacity: 1;
    ${defaultTransition}

    :hover {
      opacity: 0.8;
    }
  }
`
